import { lazy } from 'react';

const LAZY_COMPONENT = {
  Login: lazy(() => import('@pages/Auth/Login/Login')),
  ForgotPassword: lazy(() => import('@pages/Auth/ForgotPassword/ForgotPassword')),
  ResetPassword: lazy(() => import('@pages/Auth/ResetPassword/ResetPassword')),
  NotFound: lazy(() => import('@pages/NotFound/NotFound')),
  Flows: lazy(() => import('@pages/Flows/Flows')),
  Connections: lazy(() => import('@pages/Connections/Connections')),
  ConnectionView: lazy(() => import('@pages/Connections/components/EditConnection/ConnectionView')),
  ConnectionEdit: lazy(() => import('@pages/Connections/components/EditConnection/ConnectionEdit')),
  Users: lazy(() => import('@pages/Users/Users')),
  ApiUsers: lazy(() => import('@pages/ApiUsers/ApiUsers')),
  Roles: lazy(() => import('@pages/Roles/Roles')),
  ViewProfile: lazy(() => import('@pages/Profile/ViewProfile')),
  EditProfile: lazy(() => import('@pages/Profile/EditProfile')),
  UserView: lazy(() => import('@pages/Users/components/EditUser/UserView')),
  UserForm: lazy(() => import('@pages/Users/components/EditUser/UserForm')),
  ApiUserView: lazy(() => import('@pages/ApiUsers/components/EditApiUser/ApiUserView')),
  ApiUserForm: lazy(() => import('@pages/ApiUsers/components/EditApiUser/ApiUserForm')),
  RoleView: lazy(() => import('@pages/Roles/components/EditRole/RoleView')),
  RoleForm: lazy(() => import('@pages/Roles/components/EditRole/RoleForm')),
  ViewFlow: lazy(() => import('@pages/Flows/components/Flow/ViewFlow')),
  EditFlow: lazy(() => import('@pages/Flows/components/Flow/EditFlow')),
  FlowChat: lazy(() => import('@pages/Flows/components/Flow/FlowChat')),
  Logs: lazy(() => import('@pages/Logs/Logs'))
} as const;

export { LAZY_COMPONENT };
